let productCalculator = document.querySelector('.product-calculator');
if (productCalculator) {
    const calcTooltipTrigger = document.getElementById('calcTooltipTrigger');
    const calcTooltip = document.querySelector('.product-calculator__tooltip');
    if (calcTooltipTrigger && calcTooltip) {
        let isHovering = false;

        function showTooltip() {
            isHovering = true;
            calcTooltip.classList.add('product-calculator__tooltip--active');
        }

        function hideTooltip() {
            isHovering = false;
            // Delay to allow moving between trigger and tooltip
            setTimeout(() => {
                if (!isHovering) {
                    calcTooltip.classList.remove('product-calculator__tooltip--active');
                }
            }, 100);
        }

        calcTooltipTrigger.addEventListener('mouseenter', showTooltip);
        calcTooltipTrigger.addEventListener('mouseleave', hideTooltip);
        calcTooltip.addEventListener('mouseenter', showTooltip);
        calcTooltip.addEventListener('mouseleave', hideTooltip);
    }
}
